import { render, staticRenderFns } from "./SelectedCompany.vue?vue&type=template&id=f827508a&scoped=true&"
import script from "./SelectedCompany.vue?vue&type=script&lang=js&"
export * from "./SelectedCompany.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCompany.vue?vue&type=style&index=0&id=f827508a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f827508a",
  null
  
)

export default component.exports